import { render, staticRenderFns } from "./profile-information.vue?vue&type=template&id=260a2794&scoped=true&"
import script from "./profile-information.vue?vue&type=script&lang=js&"
export * from "./profile-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a2794",
  null
  
)

export default component.exports